/** @jsx jsx */
import { React } from 'react';
import { jsx } from '@emotion/core';
import { Column, Container, Row } from '../../../styles/Grid';

import DotComponent from '../../ui/DotComponent';
import * as styles from './index.style';
import Spacer from '../../ui/Spacer';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import InputForm from './InputForm';
class FeatureHero extends SafePureComponent {
  render() {
    return (
      <Spacer customCss={styles.containerSizesTop}>
        <img
          src="https://newstore.ictpvtltd.com/feature/topbannerimg.png"
          alt="banner"
        ></img>
        <div className="bannerbg">
          <Container css={[styles.itemsContainerCss]}>
            <div className="contentsec">
              <div className="texttop">
                <span className="img_icon">
                  <img
                    src={
                      'https://newstore.ictpvtltd.com/feature/enterprise.png'
                    }
                    alt="icon"
                  />
                </span>
                <h2>
                  Unlock hybrid working for your enterprise <DotComponent />
                </h2>
                <p className="ptext">
                  Allow your employees to move seamlessly between office and
                  home working.
                </p>
              </div>
            </div>
            <div className="callsectionbg">
              <div className="callsec">
                <div className="expert_call">
                  <div className="callusnow">
                    <div className="callustxt">Call us now</div>
                    <div className="callnowithicon">
                      <span>
                        <i className="icon icon-contact phone-default-icon"></i>
                      </span>
                      <span className="phone-number">022 6786 9226</span>
                    </div>
                  </div>
                  <div className="or_line">
                    <span>OR</span>
                  </div>
                  <div className="talktoexpert">
                    <div className="callustxt">Talk to one of our experts</div>
                    <div className="callnowithicon">
                      <p>We normally call you back in less than a minute.</p>
                    </div>
                  </div>
                </div>
                <div className="callme">
                  <InputForm />

                  {/* <button>BUY NOW</button> */}
                </div>
              </div>
            </div>
          </Container>
        </div>
      </Spacer>
    );
  }
}

export default FeatureHero;
